<template>
  <div :class="['station__wrapper', anchoredState, sizeState, behindState, fitHeightState, dynamicHeightState, shouldShowState]" :style="{'--dynamic-height': dynamicHeight}">
    <div v-if="hasTopSpacer" class="station__vertical-top-spacer"></div>
    <div class="station">
      <div class="station__top" :style="{'--top-left-spacer': topLeftSpacerWidth + 'px', '--top-right-spacer': topRightSpacerWidth + 'px'}">
        <div v-if="hasLeftSpacer" class="station__top-spacer station__top-spacer--left"></div>
        <div class="station__top-content">
          <slot name="top-content"></slot>
        </div>
        <div v-if="hasRightSpacer" class="station__top-spacer station__top-spacer--right"></div>
      </div>
      <div class="station__main">
        <div class="station__main-content">
          <slot name="main-content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Station',
  components: {
  },
  data() {
    return {
      dynamicHeight: 'calc(100% - 44px)',
      windowWidth: 0,
      gutterSize: 10,
      borderWidth: 2,
    }
  },
  props: ['which', 'shouldShow', 'sizeState', 'verticalSizeState', 'behind', 'hasLeftSpacer', 'hasRightSpacer', 'hasTopSpacer', 'anchored', 'fitHeight', 'hasDynamicHeight'],
  mounted() {
    if(this.which == 'main'){
      window.addEventListener("resize", this.windowResized);
      this.windowResized();
    }
  },
  methods: {
    windowResized(){
      this.windowWidth = window.innerWidth;
    },
    getColumnSize(count){
      let windowWidth = this.windowWidth;
      let columnSize = (windowWidth - (this.gutterSize * 10)) / 9;
      return columnSize * count;
    },
    updateDynamicHeight(){
      if(this.hasDynamicHeight == true) {
        if(this.verticalSizeState == 'shrink'){
          this.dynamicHeight = 'calc(' + this.$store.state.stations.right.contentHeight + ' - 44px)';
        } else {
          this.dynamicHeight = 'calc(100% - 44px)';
        }
      }
    }
  },
  computed: {
    behindState(){
      if(this.behind){
        return 'behind';
      } else {
        return '';
      }
    },
    anchoredState(){
      if(this.anchored == 'right'){
        return 'anchored-right';
      } else {
        return 'anchored-left';
      }
    },
    fitHeightState(){
      return (this.fitHeight == true ? 'station--fit-height' : '');
    },
    dynamicHeightState(){
      return (this.hasDynamicHeight == true ? 'station--dynamic-height' : '');
    },
    shouldShowState(){
      if(this.which == 'right2'){
        if(this.shouldShow){
          return '';
        } else {
          return 'hideStation';
        }
      } else {
        return '';
      }
    },
    topLeftSpacerWidth(){
      if(this.hasLeftSpacer){
        return 72;
      } else {
        return 0;
      }
      // --top-left-spacer: 131px;
      // --top-right-spacer: 263px;
    },
    topRightSpacerWidth(){
      if(this.hasLeftSpacer){
        let spacing = this.getColumnSize(2) + this.gutterSize + this.borderWidth;
        return spacing;

      } else {
        return 0;
      }
    }

  },
  watch: {
    'verticalSizeState' () {
      this.updateDynamicHeight();
    }
  }
}

</script>

<style>

/*

  one approach: use a top spacer,
    the top spacer grows to a certain height from store
    when verticalSizeState turns to shrink

  second approach: just adjust height,
    the height of the station shrinks a certain height from store
    with calc(100% - AMT)
    which lets us still use a top-spacer for the actual spacer
    but since there's gonna be one anywayyy, could re-use it

    yeah I think re-using the spacer is best here

 */

.station__wrapper,
.station,
.station__top,
.station__top-spacer,
.station__vertical-top-spacer {
  pointer-events: none;
}

.station__wrapper {
  height: 100%;
  width: 100%;
  z-index: 10;
  position: relative;
  box-sizing: border-box;
  transition: var(--transition-base);
}

.station__wrapper.behind {
  z-index: 0;
}

.station__wrapper.anchored-left {
  /* left: 0; */
}

.station__wrapper.anchored-right {
  /* right: 0; */
}

.station__wrapper.full {
  /* width: 100%; */
}

.station__wrapper.medium {
  /* width: 75%; */
}

.station__wrapper.medium .station__top-spacer {
  /* width: 0; */
}

.station__wrapper.sitMiddle .station__top-spacer--left,
.station__wrapper.sitRight .station__top-spacer--left {
  width: 0;
}

.station__wrapper.sitMiddle .station__top-spacer--right,
.station__wrapper.sitLeft .station__top-spacer--right {
  width: 0;
}

.station__wrapper.sitLeft .station__top-content {
  width: calc(100% - var(--top-left-spacer));
}

.station__wrapper.sitRight .station__top-content {
  width: calc(100% - var(--top-right-spacer));
}

.station__wrapper.sitMiddle .station__top-content {
  width: 100%;
}

.station__wrapper.sitNone {
  opacity: 0;
  pointer-events: none;
}

.station__wrapper.sitLeft {

}

.station__wrapper.small {
  /* width: 25%; */
}

.station__wrapper.hideStation {
  transition-delay: 300ms;
  transition-duration: 0ms;
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
}

.station__wrapper.hideStation .station__main-content {
  transition-duration: 250ms;
  opacity: 0;
}


.station {
  display: grid;
  grid-template-rows: 44px 1fr;
  height: 100%;
  width: 100%;
}

.station__top {
  width: 100%;
  display: flex;
  flex-direction: row;
  --top-left-spacer: 0px;
  --top-right-spacer: 0px;
}

.station__top-spacer {
  border-bottom: var(--border-station);
  transition: var(--transition-base);
}

.station__top-spacer--left {
  width: var(--top-left-spacer);
}

.station__top-spacer--right {
  width: var(--top-right-spacer);
}


.station__top-content {
  border-top: var(--border-station);
  border-left: var(--border-station);
  border-right: var(--border-station);
  width: calc(100% - var(--top-left-spacer) - var(--top-right-spacer));
  background: var(--beige-300);
  pointer-events: all;
  transition: var(--transition-base);
}

.station__vertical-top-spacer {
  --height: 44px;
  height: var(--height);
  transition: var(--transition-base);
}

.station__main {
  width: 100%;
  /* height: calc(100vh - 10px - 10px - 4px); */
  height: 100%;
  border-right: var(--border-station);
  border-bottom: var(--border-station);
  border-left: var(--border-station);
  background: var(--beige-300);
  box-sizing: border-box;
}

.station__main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - var(--station-gap)*2 - var(--border-width)*1 - var(--top-height));
  opacity: 1;
  transition: var(--transition-base);
  pointer-events: all;
}

.station--fit-height .station__main,
.station--fit-height .station__main-content {
  height: fit-content;
}

.station--dynamic-height {
}

.station--dynamic-height .station {
  height: var(--dynamic-height);
  transition: var(--transition-base);
  bottom: 0;
  position: absolute;
}

.station--dynamic-height .station__main-content {
  height: 100%;
  max-height: 100%; /* see if we need this */
}

@media (max-device-width: 600px) {

  .station {
    border-radius: var(--mobile-border-radiuses);
  }

  .station__main {
    border-radius: var(--mobile-border-radiuses);
    overflow: hidden;
  }

  .station__main-content {
    height: calc(100vh - var(--station-gap)*2 - var(--border-width)*1 - var(--top-height) - var(--mobile-top) - var(--mobile-bottom));
  }

  .station__wrapper {
    height: fit-content;
  }
}

@media screen and (max-device-width: 600px) and (orientation:landscape) {

}

</style>
